// src/pages/RimuoviUtente.jsx
import { useState, useEffect } from 'react';
import { authFetch } from '../utils/authFetch';
import { useNavigate } from 'react-router-dom';
import { Card, TableCell, TableHeadCell } from '../components/ui';

const BACKEND_URL = '/api';

// stessi ruoli e stesse etichette di AggiungiUtente
const RUOLI = [
  { value: 'admin', label: 'Admin' },
  { value: 'segreteria', label: 'Segreteria' },
  { value: 'gestione', label: 'Gestione' },
  { value: 'tecnico', label: 'Tecnico' },
  { value: 'cliente', label: 'Cliente' },
];

const RimuoviUtente = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const [resetInfo, setResetInfo] = useState(null);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editNome, setEditNome] = useState('');
  const [editCognome, setEditCognome] = useState('');
  const [editUsername, setEditUsername] = useState('');
  const [editRole, setEditRole] = useState('');
  const [editMatricola, setEditMatricola] = useState('');

  const [myRole, setMyRole] = useState(null);

  //  SOLO QUESTA PARTE � NUOVA: modale eliminazione con conferma email
  const [deleteTarget, setDeleteTarget] = useState(null); // { id, role, email, label }
  const [deleteConfirmEmail, setDeleteConfirmEmail] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);

  const fetchUsers = async () => {
    try {
      const res = await authFetch(`${BACKEND_URL}/users`);

      if (!res.ok) {
        setError('Errore nel recupero utenti');
        return;
      }

      const data = await res.json();
      setUsers(data);
      setError('');
    } catch (err) {
      console.error('Errore nel recupero utenti:', err);
      setError('Errore nella richiesta');
    }
  };

  useEffect(() => {
    fetchUsers();
    const storedRole = localStorage.getItem('role');
    if (storedRole) setMyRole(storedRole);
  }, []);

  // = helper per permessi lato UI
  const isAdmin = myRole === 'admin';
  const isGestioneOrSegreteria =
    myRole === 'gestione' || myRole === 'segreteria';

  const canEditUser = (user) => {
    if (isAdmin) return true;
    if (isGestioneOrSegreteria && user.role !== 'admin') return true;
    return false;
  };

  const canResetPasswordUser = (user) => {
    if (isAdmin) return true;
    if (isGestioneOrSegreteria && user.role !== 'admin') return true;
    return false;
  };

  const canUnlockUser = (user) => {
    if (isAdmin) return true;
    if (isGestioneOrSegreteria && user.role !== 'admin') return true;
    return false;
  };

  const deleteUser = async (id, role) => {
    if (role === 'admin') {
      setError('Non puoi eliminare un admin!');
      return;
    }

    try {
      const res = await authFetch(`${BACKEND_URL}/users/${id}`, {
        method: 'DELETE',
      });

      if (res.ok) {
        setMessage('Utente eliminato con successo');
        setError('');
        fetchUsers();
      } else {
        const data = await res.json().catch(() => null);
        setError(data?.error || 'Errore durante la rimozione');
      }
    } catch (err) {
      console.error('Errore nella richiesta:', err);
      setError('Errore nella richiesta');
    }
  };

  const resetPassword = async (user) => {
    if (!canResetPasswordUser(user)) {
      setError('Non sei autorizzato a resettare la password di questo utente.');
      return;
    }

    setMessage('');
    setError('');
    try {
      const res = await authFetch(
        `${BACKEND_URL}/users/${user._id}/reset-password`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }
      );

      const data = await res.json().catch(() => null);

      if (res.ok) {
        setResetInfo({
          username: user.username,
          matricola: user.matricola,
          tempPassword: data?.tempPassword,
        });
        setMessage('Password resettata con successo');
        fetchUsers();
      } else {
        setError(data?.error || 'Errore nel reset della password');
      }
    } catch (err) {
      console.error('Errore reset password:', err);
      setError('Errore nella richiesta');
    }
  };

  const unlockUser = async (user) => {
    if (!canUnlockUser(user)) {
      setError('Non sei autorizzato a sbloccare questo utente.');
      return;
    }

    setMessage('');
    setError('');
    try {
      const res = await authFetch(
        `${BACKEND_URL}/users/${user._id}/unlock`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        }
      );

      const data = await res.json().catch(() => null);

      if (res.ok) {
        setMessage(data?.message || 'Utente sbloccato con successo');
        fetchUsers();
      } else {
        setError(data?.error || 'Errore durante lo sblocco utente');
      }
    } catch (err) {
      console.error('Errore sblocco utente:', err);
      setError('Errore nella richiesta');
    }
  };

  const openEditModal = (user) => {
    if (!canEditUser(user)) {
      setError('Non sei autorizzato a modificare questo utente.');
      return;
    }

    setEditUser(user);
    setEditNome(user.nome || '');
    setEditCognome(user.cognome || '');
    setEditUsername(user.username || '');
    setEditMatricola(user.matricola || '');
    setEditRole(user.role || '');
    setEditModalOpen(true);
    setMessage('');
    setError('');
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setEditUser(null);
    setEditNome('');
    setEditCognome('');
    setEditUsername('');
    setEditMatricola('');
    setEditRole('');
  };

  const handleSaveUser = async (e) => {
    e.preventDefault();
    if (!editUser?._id) return;

    if (!canEditUser(editUser)) {
      setError('Non sei autorizzato a modificare questo utente.');
      return;
    }

    setMessage('');
    setError('');

    try {
      const res = await authFetch(`${BACKEND_URL}/users/${editUser._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: editNome.trim(),
          cognome: editCognome.trim(),
          username: editUsername.trim(),
          matricola: editMatricola.trim(),
          // il ruolo lo manda solo un admin (il server lo rifiuta agli altri)
          ...(isAdmin && editRole && editRole !== editUser.role ? { role: editRole } : {}),
        }),
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        setError(data?.error || "Errore durante l'aggiornamento utente");
        return;
      }

      setMessage('Dati utente aggiornati con successo');
      closeEditModal();
      fetchUsers();
    } catch (err) {
      console.error('Errore aggiornamento utente:', err);
      setError('Errore nella richiesta');
    }
  };

  //  AGGIUNTO SOLO deleteTarget QUI, il resto identico
  useEffect(() => {
    if (editModalOpen || resetInfo || deleteTarget) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [editModalOpen, resetInfo, deleteTarget]);

  //  SOLO QUESTA PARTE � NUOVA: apertura/chiusura/confirm modale elimina
  const openDeleteModal = (user) => {
    if (!user?._id) return;

    if (user.role === 'admin') {
      setError('Non puoi eliminare un admin!');
      return;
    }

    setMessage('');
    setError('');
    setDeleteTarget({
      id: user._id,
      role: user.role,
      email: user.username,
      label: `${user.nome || ''} ${user.cognome || ''}`.trim() || user.username,
    });
    setDeleteConfirmEmail('');
    setDeleteLoading(false);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setDeleteConfirmEmail('');
    setDeleteLoading(false);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;

    const expected = (deleteTarget.email || '').trim().toLowerCase();
    const typed = (deleteConfirmEmail || '').trim().toLowerCase();

    if (!typed) {
      setError("Per eliminare devi inserire l'email esatta dell'utente.");
      return;
    }
    if (typed !== expected) {
      setError('Email non corretta, eliminazione annullata.');
      return;
    }

    setDeleteLoading(true);
    setError('');

    try {
      await deleteUser(deleteTarget.id, deleteTarget.role);
      closeDeleteModal();
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-6 px-3 md:px-6 flex justify-center">
      <div className="w-full max-w-5xl space-y-6">
        <Card className="shadow-sm px-4 py-3 md:px-6 md:py-4">
          <h2 className="text-xl md:text-2xl font-semibold text-gray-800 text-center">
            Gestione Utenti
          </h2>

          <p className="mt-1 text-xs md:text-sm text-gray-500 text-center">
            Visualizza, modifica o rimuovi gli account esistenti. Gli admin non possono essere eliminati.
          </p>
          {/* Bottone torna indietro */}
          <button
            onClick={() => navigate('/dashboard')}
            className="hidden md:inline-flex px-3 py-1.5 rounded-lg text-xs bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            ← Torna alla dashboard
          </button>
        </Card>

        {(message || error) && (
          <Card className="shadow-sm px-4 py-3 md:px-6">
            {message && (
              <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2 mb-1">
                {message}
              </p>
            )}
            {error && (
              <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                {error}
              </p>
            )}
          </Card>
        )}

        <Card className="shadow-sm p-4 md:p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Utenti attivi
          </h3>

          {users.length === 0 ? (
            <p className="text-sm text-gray-500">
              Nessun utente registrato al momento.
            </p>
          ) : (
            <>
              <p className="text-[11px] text-gray-400 mb-2 md:hidden">
                Scorri orizzontalmente la tabella per visualizzare tutti i dati.
              </p>

              <div className="overflow-x-auto">
                <table className="min-w-full border-collapse text-xs md:text-sm">
                  <thead>
                    <tr className="bg-gray-50 text-gray-700">
                      <TableHeadCell className="px-3 py-2 text-left">
                        Nome
                      </TableHeadCell>
                      <TableHeadCell className="px-3 py-2 text-left">
                        Cognome
                      </TableHeadCell>
                      <TableHeadCell className="px-3 py-2 text-left">
                        Email
                      </TableHeadCell>
                      <TableHeadCell className="px-3 py-2 text-left">
                        Matricola
                      </TableHeadCell>
                      <TableHeadCell className="px-3 py-2 text-left">
                        Ruolo
                      </TableHeadCell>
                      <TableHeadCell className="px-3 py-2 text-left">
                        Stato
                      </TableHeadCell>
                      <TableHeadCell className="px-3 py-2 text-left">
                        Azioni
                      </TableHeadCell>
                    </tr>
                  </thead>
                  <tbody>
                    {users
                      .filter((user) => {
                        if (user.nome === 'Da' && user.cognome === 'Assegnare') {
                          return myRole === 'admin'; // solo admin lo vede
                        }
                        return true;
                      })
                      .map((user) => (
                        <tr
                          key={user._id}
                          className="border-b last:border-b-0 hover:bg-gray-50"
                        >
                          <TableCell className="px-3 py-2">
                            {user.nome || '-'}
                          </TableCell>
                          <TableCell className="px-3 py-2">
                            {user.cognome || '-'}
                          </TableCell>
                          <TableCell className="px-3 py-2">
                            <span className="block truncate max-w-[140px] md:max-w-xs">
                              {user.username}
                            </span>
                          </TableCell>
                          <TableCell className="px-3 py-2">
                            {user.matricola || '-'}
                          </TableCell>
                          <TableCell className="px-3 py-2">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-700 uppercase">
                              {user.role}
                            </span>
                          </TableCell>
                          <TableCell className="px-3 py-2">
                            {user.isLocked ? (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] font-semibold bg-red-100 text-red-700">
                                Bloccato
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] font-semibold bg-emerald-100 text-emerald-700">
                                Attivo
                              </span>
                            )}
                          </TableCell>
                          <TableCell className="px-3 py-2">
                            <div className="flex flex-wrap gap-1">
                              {canEditUser(user) && (
                                <button
                                  onClick={() => openEditModal(user)}
                                  className="px-3 py-1 rounded-lg bg-amber-500 text-white text-[11px] md:text-xs font-semibold hover:bg-amber-600 transition"
                                >
                                  Modifica
                                </button>
                              )}

                              {canResetPasswordUser(user) && (
                                <button
                                  onClick={() => resetPassword(user)}
                                  className="px-3 py-1 rounded-lg bg-blue-600 text-white text-[11px] md:text-xs font-semibold hover:bg-blue-700 transition"
                                >
                                  Reset password
                                </button>
                              )}

                              {user.isLocked && canUnlockUser(user) && (
                                <button
                                  onClick={() => unlockUser(user)}
                                  className="px-3 py-1 rounded-lg bg-purple-600 text-white text-[11px] md:text-xs font-semibold hover:bg-purple-700 transition"
                                >
                                  Sblocca
                                </button>
                              )}

                              {/*  UNICA MODIFICA: qui non cancella subito, apre modale */}
                              <button
                                onClick={() => openDeleteModal(user)}
                                disabled={user.role === 'admin'}
                                className={`px-3 py-1 rounded-lg text-[11px] md:text-xs font-semibold transition ${
                                  user.role === 'admin'
                                    ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                                    : 'bg-red-600 text-white hover:bg-red-700'
                                }`}
                              >
                                Elimina
                              </button>
                            </div>
                          </TableCell>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Card>
        <button
          onClick={() => navigate('/dashboard')}
          className="mt-2 px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-xs font-medium hover:bg-gray-200"
        >
          ← Torna alla dashboard
        </button>
      </div>

      {/* Popup RESET PASSWORD */}
      {resetInfo && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg p-6 max-w-sm w-full mx-4">
            <h3 className="text-lg font-semibold mb-3">
              Password temporanea generata
            </h3>
            <p className="mb-1">
              <strong>Utente:</strong> {resetInfo.username}
            </p>
            <p className="mb-1">
              <strong>Matricola:</strong> {resetInfo.matricola || '-'}
            </p>
            <p className="mb-3">
              <strong>Nuova password temporanea:</strong>{' '}
              <span className="font-mono bg-gray-100 px-2 py-1 rounded">
                {resetInfo.tempPassword}
              </span>
            </p>
            <p className="text-sm text-gray-600 mb-4">
              Comunica questa password all&apos;utente. Al prossimo accesso dovrà
              cambiarla.
            </p>
            <button
              onClick={() => setResetInfo(null)}
              className="w-full bg-blue-600 text-white py-2 rounded-lg text-sm font-semibold hover:bg-blue-700 transition"
            >
              Chiudi
            </button>
          </div>
        </div>
      )}

      {/* Popup MODIFICA UTENTE */}
      {editModalOpen && editUser && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold mb-3">Modifica utente</h3>
            <form onSubmit={handleSaveUser} className="space-y-3 text-sm">
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Nome
                </label>
                <input
                  type="text"
                  value={editNome}
                  onChange={(e) => setEditNome(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Cognome
                </label>
                <input
                  type="text"
                  value={editCognome}
                  onChange={(e) => setEditCognome(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Email (username di accesso)
                </label>
                <input
                  type="email"
                  value={editUsername}
                  onChange={(e) => setEditUsername(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Matricola
                </label>
                <input
                  type="text"
                  value={editMatricola}
                  onChange={(e) => setEditMatricola(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                />
              </div>

              {/* Ruolo: solo un admin puo cambiarlo, anche a un altro admin */}
              {isAdmin && (
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Ruolo
                  </label>
                  <select
                    value={editRole}
                    onChange={(e) => setEditRole(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-sky-500"
                  >
                    {RUOLI.map((r) => (
                      <option key={r.value} value={r.value}>
                        {r.label}
                      </option>
                    ))}
                  </select>
                  {editUser.role === 'admin' && editRole !== 'admin' && (
                    <p className="mt-1 text-xs text-amber-700">
                      Stai togliendo i privilegi di admin a questo utente. Se e l'ultimo admin
                      rimasto il server rifiutera la modifica.
                    </p>
                  )}
                </div>
              )}

              <div className="flex justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50"
                >
                  Annulla
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700"
                >
                  Salva modifiche
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/*  SOLO QUESTA PARTE � NUOVA: Popup ELIMINA UTENTE */}
      {deleteTarget && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
          onClick={closeDeleteModal}
        >
          <div
            className="bg-white rounded-2xl shadow-lg p-6 max-w-sm w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold mb-2 text-red-700">
              Conferma eliminazione utente
            </h3>

            <p className="text-sm text-gray-700 mb-2">
              Stai per eliminare l&apos;utente{' '}
              <span className="font-semibold">{deleteTarget.label}</span>.
            </p>

            <p className="text-sm text-gray-700 mb-4">
              Operazione non reversibile. Per confermare, digita esattamente
              l&apos;email dell&apos;utente:
              <span className="font-mono font-semibold">
                {' '}
                {deleteTarget.email}
              </span>
            </p>

            <input
              type="email"
              value={deleteConfirmEmail}
              onChange={(e) => setDeleteConfirmEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleConfirmDelete();
                }
              }}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 mb-4"
              placeholder={deleteTarget.email}
              disabled={deleteLoading}
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={closeDeleteModal}
                className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200"
                disabled={deleteLoading}
              >
                Annulla
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 disabled:opacity-60"
                disabled={deleteLoading}
              >
                {deleteLoading ? 'Eliminazione...' : 'Elimina'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RimuoviUtente;
